import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";
// import Export from "../../component/Export";

const ViewRooms = () => {
  const [loading, setLoading] = useState(false);
  const [rooms, setRooms] = useState([]);
  const token = config.token;
  const navigate = useNavigate();
  //  ------For TableViewer ------
  const roomsRef = useRef([]);
  roomsRef.current = rooms;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}rooms`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setRooms(data.data);

        //  ------For TableViewer ------
        const roomsData = data.data.map((room) => ({
          room: room.room,
          idNumber: room.roomid,
        }));
        setRowData(roomsData);
        //  ------For TableViewer ------

        setLoading(false);
      });
  }, [token]);

  //----------------------------------------------- Export xlsx File ----------------------------------------------
  const handleExport = () =>
    rooms.map((room) => {
      return { room: room.room };
    });

  // ------------------------------------------------------------------ Delete Room -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Room. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${config.host_url}rooms/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          // console.log("Response:", response);
          return response.json();
        })
        .then(function (data) {
          // console.log("Data:", data);
          if (data.status === 200) {
            triggerNotification("success", "Room deleted successfully");

            //  ------For TableViewer ------
            const updatedRooms = [...roomsRef.current];
            updatedRooms.splice(i, 1);
            setRooms(updatedRooms);

            const roomsData = updatedRooms.map((room) => ({
              room: room.room,
              idNumber: room.roomid,
            }));
            setRowData(roomsData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            triggerNotification("error", "Room not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", "Error deleting Room");
        });
    };
  };

  // ------------------------------------------------------------------ edit Room -----------------------------------------------------U
  const handleEditBtn = (id) => {
    navigate(`/addroom/${btoa(encodeURIComponent(id))}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "room", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Room" subpath={["View Rooms"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Rooms</h5>
            <div>
              {/* <Export onExport={handleExport} /> */}
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addroom");
                }}
              >
                Add Room
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewRooms;
